module.exports = __webpack_public_path__ + "img/sign.01b22d26.svg";